'use strict';

import {
    AVAILABLE_STATUS,
    Buildings,
    cardsData, components, isDesktop,
    isMobile, isTablet,
    projectMode,
    settingsData,
    threeJsVariables,
} from '../../settings';
import {hideTooltip, showTooltip, updateTooltipPosition, updateTooltipText} from "../components/flatTooltip/flatTooltip";
import {SelectedObjectType, ViewMode} from "../../common";
import {cylinderFloorNumbersIntersection} from "../components/cylinderFloorNumbers/cylinderFloorNumbers";
import {
    findSelectionAndCrmData,
    flatClick,
    rgbaToHexA,
    userPrevent,
} from '../../functions';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import { updateHoverPosition } from '../components/building-switch/buildingHover';
import { doubleEventCheck } from '../controls/mouse-n-touches';
import { Amenities } from '../components/Amenities/Amenities';
import { PublicLayers } from '../components/publicLayers/PublicLayers';
import {toggleMenuWidth} from "../menu/menu";
import { Environment } from '../components/Environment/Environment';
import {compassClickHandler} from "../components/compass/compass";
import { LinearSRGBColorSpace, Quaternion } from 'three';
import {BmbyMode} from "../mode/BmbyMode";

let {hoveredObject} = settingsData;

export function checkIntersection(action) {
    let canvas = document.getElementById('c');
    const flatTooltip = document.querySelector('.flat-tooltip');
    if (flatTooltip && getComputedStyle(flatTooltip).display !== 'none')
        showTooltip();

    if (isTablet) {
        const isHomeMenuButtonActive =
          Boolean(document.querySelector(
            '.aside__navigation-menu__item.aside__active-menu[data-menu-item="3dModel"]'
          ));
        if (!isHomeMenuButtonActive)
            toggleMenuWidth({action: 'mini', source: 'eventListener'});
    }

    if (
        (!threeJsVariables.orbitControls.enabled &&
         !projectMode.LiteMode.isVisible()) || !canvas || settingsData.intersectionBlock) {
        hideTooltip();
        return;
    }

    let intersects = [];
    intersects = threeJsVariables.raycaster.intersectObjects(settingsData.objects_to_intersection, false);
    if (intersects.length === 0 || intersects[0].object.name.split('_')[0] === 'zero')
        hideTooltip();
    if (intersects.length > 0) {
        if (!isMobile && !settingsData.customCursor)
            canvas.style.cursor = 'pointer';
        if (settingsData.selectedObject !== intersects[0].object) {
            settingsData.selectedObject = intersects[0].object;
            intersectionMouseOverHandler(settingsData.selectedObject);
        } else if (action === 'click') {
            doubleEventCheck(intersects[0].object);
            if (settingsData.activeViewMode === ViewMode.Orbit) {
                switch (settingsData.selectedObject.userData?.type) {
                    case SelectedObjectType.Neighborhood:
                        projectMode.LiteMode.neighborhood.clickIntersection(settingsData.selectedObject);
                        break;
                    case SelectedObjectType.Building:
                        projectMode.Cylinder.enter(settingsData.selectedObject);
                        break;
                }
            } else {
                intersectionClickHandler(settingsData.selectedObject);
                if (settingsData.selectedObject.userData.type === "selectionBoxes") {
                    settingsData.isFlat = true;
                    if (isMobile)
                        components.mobileSearch.unfold();
                }
            }
        } else if (action === 'pointerdown') {
            if (settingsData.activeViewMode === ViewMode.Orbit) {
                switch (settingsData.selectedObject.userData?.type) {
                    case SelectedObjectType.Cloth:
                        threeJsVariables.orbitControls.enableRotate = true;
                        threeJsVariables.cloth.removeCloth();
                        threeJsVariables.cloth.hovered = false;
                        break;
                }
            }
        } else if (action === 'drag') {}
    } else {
        if (!isMobile && !settingsData.customCursor)
            canvas.style.cursor = 'default';
        if (settingsData.selectedObject) {
            switch (settingsData.selectedObject.userData?.type) {
                case SelectedObjectType.Neighborhood:
                    projectMode.LiteMode.neighborhood.intersected(null);
                    break;
                case SelectedObjectType.Building:
                    buildingHoverOut();
                    break;
                case SelectedObjectType.SelectionBoxes:
                    selectionBoxesSetStatusColor(settingsData.selectedObject, 'hoverOut');
                    break;
                case SelectedObjectType.Route:
                    PublicLayers.intersect();
                    Environment.intersect();
                    break;
                case SelectedObjectType.Cloth:
                    clothHoverOut();
                    break;
            }
            settingsData.selectedObject = null;
            settingsData.isFlat = false;
        }

        if (isMobile && components?.mobileSearch)
            components.mobileSearch.fold();
    }
    cylinderFloorNumbersIntersection(action);
}

function buildingHover(pickedObject) {
    if (pickedObject === undefined) {
        buildingHoverOut();
        return;
    }
    buildingHoverOut();
    if (settingsData.activeViewMode === ViewMode.Orbit) {
        const {isActive, effectFXAA} = settingsData.postProcessing;
        let pickedBuilding;
        let pickedBuildingName;
        let buildingInfo;

        if (projectMode.LiteMode.isActive() && projectMode.LiteMode.isVisible()) {
            pickedBuilding = pickedObject.name.split('_')[0];
            pickedBuildingName = pickedBuilding;
            buildingInfo = Buildings.getBuilding(pickedBuilding);
            if (buildingInfo) {
                buildingInfo.mouseHover = true;
                pickedObject.material.color.setHex(0xffffff,LinearSRGBColorSpace);
                pickedObject.material.opacity = 0.2;
            } else if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('picture')) {
                pickedObject.material.color.setHex(0xffffff,LinearSRGBColorSpace);
                pickedObject.material.opacity = 0.2;
            }

        } else {
            pickedBuilding = pickedObject.parent;
            pickedBuildingName = pickedBuilding.name;
            buildingInfo = Buildings.getBuilding(pickedBuilding.name);
        }
        
        if (config.features.privateHouseMode && !isMobile) {
            const buildingLabel = document.querySelector('.building-labels_wrapper[data-name="privateHouse"]');
            if (buildingLabel) {
                buildingLabel.classList.add('building__hovered');
            }
            
            buildingInfo.mouseHover = true;
            
        } else if (config.threejs.label.oneLabel && !isMobile) {
            const buildingLabel = document.querySelector('.building-labels_wrapper[data-name="oneLabel"]');
            if (buildingLabel) {
                buildingLabel.classList.add('building__hovered');
            }
    
            buildingInfo.mouseHover = true;
            
        } else if (buildingInfo && Object.keys(buildingInfo.info).length) {
            const buildingLabel = document.querySelector('.building-labels_wrapper[data-name="'+pickedBuildingName+'"]');
            if (buildingLabel && !isMobile) {
                buildingLabel.classList.add('building__hovered');
                const labelOnScene = threeJsVariables.scene.getObjectByName(buildingLabel.getAttribute('data-label'));
                settingsData.customCursor = true;
                updateHoverPosition(pickedBuilding,labelOnScene.position.y / 2,'show');
    
                // if (isActive && effectFXAA)
                //     threeJsVariables.outlinePass.selectedObject = pickedObject;
            }
           

            buildingInfo.mouseHover = true;
        }
    }
}

export function buildingHoverOut() {
    if (projectMode.LiteMode.isActive() && projectMode.LiteMode.isVisible() && projectMode.LiteMode.modeIs('picture') && settingsData.selectedObject)
        settingsData.selectedObject.material.opacity = 0;

    const {isActive, effectFXAA} = settingsData.postProcessing;
    const buildingHover = Buildings.getBuildingsArray().find(building => building.mouseHover);
    if (buildingHover) {
        const buildingLabel = document.querySelector('.building-labels_wrapper.building__hovered');
        settingsData.customCursor = false;
        updateHoverPosition(null,null,'hide');

        if (isActive && effectFXAA)
            threeJsVariables.outlinePass.selectedObject = null;

        if (buildingLabel)
            buildingLabel.classList.remove('building__hovered');

        if (projectMode.LiteMode.isActive() && projectMode.LiteMode.isVisible()) {
            const hovered = settingsData.objects_to_intersection.find(el => el.name.startsWith(buildingHover.name));
            if (hovered)
                hovered.material.opacity = 0;
        }
        buildingHover.mouseHover = false;
    }
}

function clothHover(selectedObject) {
    threeJsVariables.orbitControls.enableRotate = false;
    threeJsVariables.cloth.hovered = true;
    //hoveredObject = selectedObject;
}

function clothHoverOut() {
    threeJsVariables.orbitControls.enableRotate = true;
    threeJsVariables.cloth.hovered = false;
}

export async function intersectionClickHandler(selectedObject) {
    if (settingsData.buildingDestroyed
      && selectedObject.userData?.customSelection
      && selectedObject.userData?.type !== SelectedObjectType.Plug
      && !config.features?.keyplanAmenities)
        return;

    // if (isMobile && settingsData.activeViewMode === ViewMode.FloorPlan)
    //     return;
    if (selectedObject.userData?.type === SelectedObjectType.Plug && settingsData.buildingDestroyed) {
        projectMode.FloorPlan.floorAmenities.show(selectedObject);
        return;
    } else if (selectedObject.userData?.type === SelectedObjectType.Arrow) {
        compassClickHandler(selectedObject);
        return;
    } else if (selectedObject.userData?.type !== SelectedObjectType.SelectionBoxes && !selectedObject.userData.customSelection) {
        return;
    } else if (isMobile && selectedObject.userData?.type !== SelectedObjectType.Arrow && (selectedObject.userData.crm_data.status !== AVAILABLE_STATUS || !selectedObject.userData.isInSearch)) {
        return
    }

    Amenities.unselectAmenities();
    hoverOutPreviousSelection(UnitCardClass.findCard()?.html, selectedObject);

    if (settingsData.buildingDestroyed)
        selectionBoxesSetStatusColor(selectedObject, 'lock');

    if (selectedObject?.userData?.crm_data?.engineId !== '')
        selectionBoxesSetStatusColor(selectedObject, 'click');

    await flatClick(selectedObject);
}

function intersectionMouseOverHandler(selectedObject) {
    if (!selectedObject.userData?.isClicked) {
        switch (selectedObject.userData?.type) {
            case SelectedObjectType.Neighborhood:
                projectMode.LiteMode.neighborhood.intersected(selectedObject);
                break;
            case SelectedObjectType.Building:
                buildingHover(selectedObject);
                PublicLayers.intersect();
                Environment.intersect();
                break;
            case SelectedObjectType.SelectionBoxes: {
                if (hoveredObject !== null)
                    selectionBoxesSetStatusColor(hoveredObject, 'hoverOut');

                selectionBoxesSetStatusColor(selectedObject, 'hover');
                break;
            }
            case SelectedObjectType.Route: {
                PublicLayers.intersect(selectedObject);
                Environment.intersect(selectedObject);
                break;
            }
            case SelectedObjectType.Cloth: {
                clothHover(selectedObject);
                break;
            }
        }
        if (selectedObject.userData?.type !== SelectedObjectType.Cloth && threeJsVariables.cloth.hovered)
            clothHoverOut(selectedObject);
    } else {
        if (hoveredObject)
            selectionBoxesSetStatusColor(hoveredObject, 'hoverOut');

        hideTooltip();
    }
}

export function selectionBoxesSetStatusColor(selectedObject, action, tooltipFlag, customColor,switchBuildings = false) {
    if (!selectedObject || selectedObject.name.startsWith(config.resources.bundle.selectionBoxes.floorPlugName))
        return;

    let activeBuilding;
    (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('picture')) || config.features.privateHouseMode ?
        activeBuilding = Buildings.getBuilding(selectedObject.userData?.crm_data?.buildingEngineId):
        activeBuilding = Buildings.getActiveBuilding();

    if (!activeBuilding)
        return;

    const crmDataObject = activeBuilding.info.crm_data.find(apt => selectedObject.name === apt.engineId);
    const objectStatus = (crmDataObject) ? crmDataObject.status.toLowerCase() : 'available';
    const colorStatus = config.resources.bundle.selectionBoxes.colorStatus;
    const color = colorStatus.find(c => c.status === objectStatus);
    const opacity = color.opacity;

    switch (action) {
        case 'hover': {
            if (isMobile || isDesktop)
                return;

            if (selectedObject.userData.customSelection) {
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);

                selectedObject.material.color.setHex(`0x${customColor}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = opacity.hover;
                hoveredObject = selectedObject;
            } else {
                selectedObject.material.color.setHex(`0x${color.hover}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = opacity.hover;

                // show OutlineEdge depends on the opacity intensity
                if (config.resources.bundle.selectionBoxes.edges.active) {
                    const outline = selectedObject.children.find(child => child.name === "Outline");
                    if (outline)
                        outline.visible = Boolean(selectedObject.material.opacity);
                }
    
                if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('schematic') || projectMode.AirMode.isSchematicBuildings()) {
                    const aptNum = selectedObject.children.find(child => child.name === "AptNum");
                    if (aptNum)
                        aptNum.visible = Boolean(selectedObject.material.opacity);
                }

                hoveredObject = selectedObject;
            }

            if (!settingsData.buildingDestroyed || (config.features?.keyplanAmenities && settingsData.selectedObject.userData?.customSelection)) {
                updateTooltipText(selectedObject, crmDataObject);
                settingsData.lastHoverObject = updateTooltipPosition(hoveredObject);
            }
            break;
        }
        case 'hoverOut': {
            if (selectedObject.userData.isClicked)
                return;

            if (!selectedObject.userData.isClicked) {
                selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = (selectedObject.userData?.isActive) ? opacity.basic : 0;
            }

            if (!selectedObject.userData.isClicked) {
                selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = opacity.basic;
            }

            if ((!selectedObject.userData.isInSearch && settingsData.activeViewMode !== 'floorplan' && !color.isActive) || switchBuildings || selectedObject.userData.crm_data.buildingEngineId !== activeBuilding.name) {
                selectedObject.material.opacity = 0;

                // hide OutlineEdge depends on the opacity intensity
                // if (config.resources.bundle.selectionBoxes.edges.active) {
                //     const outline = selectedObject.children.find(child => child.name === "Outline");
                //     if (outline)
                //         outline.visible = Boolean(selectedObject.material.opacity);
                // }
            }

            if (settingsData.activeViewMode === 'floorplan' && !selectedObject.userData.isInSearch && objectStatus === 'available')
                selectedObject.material.opacity = 0;
    
            if (settingsData.activeViewMode === 'floorplan' && selectedObject.userData.floor === settingsData.currentFloor) {
                if (selectedObject.userData.isClicked) {
                    selectedObject.material.color.setHex(`0x${color.active}`,LinearSRGBColorSpace);
                    selectedObject.material.opacity = opacity.hover;
                } else {
                    selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
                    selectedObject.material.opacity = projectMode.LiteMode.modeIs('schematic') ? opacity.basic : 0.3;
                }
            }

            if (selectedObject.name.match(/_amenity_/g)) {
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);
                selectedObject.material.color.setHex(`0x${customColor}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = 0.0;
            }
    
            if (config.resources.bundle.selectionBoxes.edges.active) {
                const outline = selectedObject.children.find(child => child.name === "Outline");
                if (outline)
                    outline.visible = Boolean(selectedObject.material.opacity);
            }
    
            if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('schematic') || projectMode.AirMode.isSchematicBuildings()) {
                const aptNum = selectedObject.children.find(child => child.name === "AptNum");
                if (aptNum)
                    aptNum.visible = Boolean(selectedObject.material.opacity);
            }

            if (isMobile || tooltipFlag)
                return;

            hideTooltip();
            break;
        }
        case 'amenityHover':{
            selectedObject.material.color.setHex(`0x${customColor}`,LinearSRGBColorSpace);
            selectedObject.material.opacity = opacity.hover;

            break;
        }
        case 'click': {
            if (userPrevent())
                return;

            if (selectedObject.userData.customSelection){
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);
                selectedObject.material.color.setHex(`0x${customColor}`,LinearSRGBColorSpace);
            } else {
                selectedObject.material.color.setHex(`0x${color.active}`,LinearSRGBColorSpace);
            }

            selectedObject.userData.isClicked = true;
            selectedObject.material.opacity = opacity.hover;
            
            if (config.features.privateHouseMode && selectedObject.userData.crm_data?.status.toLowerCase() !== 'available' && !color.isActive) {
                selectedObject.material.opacity = 0;
            }
            
            settingsData.lastClickedFlat = selectedObject;
            return;
        }
        case 'lock': {
            selectedObject.userData.isActive = true;
            if (!selectedObject.userData.isClicked || !selectedObject.userData.isInSearch) {
                selectedObject.material.opacity = opacity.basic;
                selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
            }

            if (settingsData.activeViewMode === 'floorplan') {
                selectedObject.material.opacity = projectMode.LiteMode.modeIs('schematic') ? opacity.basic : 0.3;
                if (selectedObject.userData.isClicked) {
                    selectedObject.material.opacity = opacity.hover;
                }
            }
    
            if (settingsData.activeViewMode === 'floorplan' && selectedObject.userData.floor === settingsData.currentFloor) {
                if (selectedObject.userData.isClicked) {
                    selectedObject.material.color.setHex(`0x${color.active}`,LinearSRGBColorSpace);
                    selectedObject.material.opacity = opacity.hover;
                } else {
                    selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
                    selectedObject.material.opacity = projectMode.LiteMode.modeIs('schematic') ? opacity.basic : 0.3;
                }
            }
    
            if (selectedObject.name.match(/_amenity_/g)) {
                selectedObject.material.opacity = 0.0;
            }


            // if (config.resources.bundle.selectionBoxes.edges.active && !projectMode.LiteMode.modeIs('schematic') && selectedObject.visible && selectedObject.material.opacity > 0) {
            //     const outline = selectedObject.getObjectByName('Outline');
            //     if (outline) {
            //         outline.visible = true;
            //     }
            // }

            if (config.resources.bundle.selectionBoxes.edges.active) {
                const outline = selectedObject.getObjectByName('Outline');
                if (outline) {
                    outline.visible = selectedObject.material.opacity !== 0;
                }
            }
    
            if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('schematic') || projectMode.AirMode.isSchematicBuildings()) {
                const aptNum = selectedObject.children.find(child => child.name === "AptNum");
                if (aptNum)
                    aptNum.visible = Boolean(selectedObject.material.opacity);
            }

            break;
        }
        case 'unlock': {
            if (!selectedObject.userData.isInSearch) {
                selectedObject.userData.isActive = false;
                selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = color.isActive && !switchBuildings ? opacity.basic : 0;
            }

            // if (settingsData.activeViewMode === 'floorplan' && selectedObject.userData.floor === settingsData.currentFloor) {
            //     selectedObject.material.opacity = 0.3;
            // }
    
            if (settingsData.activeViewMode === 'floorplan' && selectedObject.userData.floor === settingsData.currentFloor) {
                if (selectedObject.userData.isClicked) {
                    selectedObject.material.color.setHex(`0x${color.active}`,LinearSRGBColorSpace);
                    selectedObject.material.opacity = opacity.hover;
                } else {
                    selectedObject.material.color.setHex(`0x${color.basic}`,LinearSRGBColorSpace);
                    selectedObject.material.opacity = projectMode.LiteMode.modeIs('schematic') ? opacity.basic : 0.3;
                }
            }
    
            if (selectedObject.name.match(/_amenity_/g)) {
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);
                selectedObject.material.color.setHex(`0x${customColor}`,LinearSRGBColorSpace);
                selectedObject.material.opacity = 0;
            }

            if (config.resources.bundle.selectionBoxes.edges.active) {
                const outline = selectedObject.getObjectByName('Outline');
                if (outline) {
                    outline.visible = selectedObject.material.opacity !== 0;
                }
            }
    
            if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('schematic') || projectMode.AirMode.isSchematicBuildings()) {
                const aptNum = selectedObject.children.find(child => child.name === "AptNum");
                if (aptNum)
                    aptNum.visible = Boolean(selectedObject.material.opacity);
            }

            break;
        }
        default: {
            break;
        }
    }
}

export const hoverOutPreviousSelection = (unitCard, currentClickedObject) => {
    if (!isMobile && !unitCard)
        return;

    let activeCard;
    if (settingsData.lastClickedFlat) {
        if (isMobile && settingsData.lastClickedFlat.name !== currentClickedObject?.name) {
            projectMode.Cylinder.cylinderBuildingLabels.markLabel(settingsData.lastClickedFlat.userData.crm_data.buildingEngineId, 'close');
            const {selectedMesh} = findSelectionAndCrmData(settingsData.lastClickedFlat.name);
            if (selectedMesh) {
                selectedMesh.userData.isClicked = false;
                selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
            }
        } else {
            cardsData.multiplyCards ?
                activeCard = UnitCardClass.cards.length > 1 && UnitCardClass.findCard(false, 'active').html.getAttribute('data-engineid'):
                activeCard = unitCard?.getAttribute('data-engineid');

            if (activeCard) {
                const {selectedMesh} = findSelectionAndCrmData(activeCard);
                selectedMesh.userData.isClicked = false;
                selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
            }
        }
    }
}
